import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "form-group row" };
const _hoisted_3 = {
    class: "col-sm-3 col-form-label",
    for: "editExpiry"
};
const _hoisted_4 = { class: "col-sm-9 pt-1" };
const _hoisted_5 = { class: "input-group" };
const _hoisted_6 = { class: "form-group row" };
const _hoisted_7 = {
    class: "col-sm-3 col-form-label",
    for: "inputTenant"
};
const _hoisted_8 = { class: "col-sm-9" };
const _hoisted_9 = ["placeholder"];
const _hoisted_10 = { class: "form-group row" };
const _hoisted_11 = {
    class: "col-sm-3 col-form-label",
    for: "editCount"
};
const _hoisted_12 = { class: "col-sm-9" };
const _hoisted_13 = ["placeholder"];
const _hoisted_14 = { class: "form-group row" };
const _hoisted_15 = {
    class: "col-sm-3 col-form-label",
    for: "used"
};
const _hoisted_16 = { class: "col-sm-9" };
const _hoisted_17 = ["value"];
const _hoisted_18 = { class: "form-group row" };
const _hoisted_19 = {
    class: "col-sm-3 col-form-label",
    for: "editActive"
};
const _hoisted_20 = { class: "col-sm-9 row ml-0" };
const _hoisted_21 = { class: "modal-footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "editCodeModal",
            "no-footer": "",
            centered: "",
            size: "lg",
            title: _ctx.$t('JTADM_CODES_EDIT_CODE')
        }, {
            default: _withCtx(() => [
                ($setup.code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("form", null, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('JTADM_CODES_EXPIRY')), 1),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createVNode($setup["BInput"], {
                                            id: "editExpiry",
                                            modelValue: $setup.code.expires_at,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.code.expires_at) = $event)),
                                            type: "date",
                                            placeholder: _ctx.$t('JTADM_CODES_SELECT_A_DATE')
                                        }, null, 8, ["modelValue", "placeholder"])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('JTADM_CODES_TENANT')), 1),
                                _createElementVNode("div", _hoisted_8, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        id: "inputTenant",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.code.tenant) = $event)),
                                        type: "text",
                                        placeholder: _ctx.$t('JTADM_CODES_TENANT'),
                                        disabled: ""
                                    }, null, 8, _hoisted_9), [
                                        [
                                            _vModelText,
                                            $setup.code.tenant,
                                            void 0,
                                            { number: true }
                                        ]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('JTADM_CODES_USABLE_FOR')), 1),
                                _createElementVNode("div", _hoisted_12, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        id: "editCount",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.code.use_count) = $event)),
                                        type: "number",
                                        placeholder: _ctx.$t('JTADM_CODES_NUMBER_OF_TIMES')
                                    }, null, 8, _hoisted_13), [
                                        [
                                            _vModelText,
                                            $setup.code.use_count,
                                            void 0,
                                            { number: true }
                                        ]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('JTADM_CODES_USED')), 1),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("input", {
                                        class: "form-control",
                                        id: "used",
                                        value: $setup.code.used,
                                        disabled: ""
                                    }, null, 8, _hoisted_17)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('JTADM_CODES_ACTIVE')), 1),
                                _createElementVNode("div", _hoisted_20, [
                                    _createVNode($setup["CommonSwitchInput"], {
                                        value: $setup.code.active,
                                        onChange: _cache[3] || (_cache[3] = ($event) => ($setup.code.active = !$setup.code.active))
                                    }, null, 8, ["value"])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("footer", _hoisted_21, [
                    _createElementVNode("button", {
                        class: "btn btn-info text-white",
                        type: "submit",
                        onClick: _withModifiers($setup.editSubmit, ["prevent"])
                    }, _toDisplayString(_ctx.$t('JTADM_UPDATE')), 1),
                    _createElementVNode("button", {
                        class: "btn btn-danger",
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => ($setup.editCodeModal?.hide()), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                ])
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
